import React, { createContext, useContext, useState, ReactNode } from 'react';
import { BookeventInputReqDTO } from '../dto/BookeventDTOs';

interface NoobookContextType {
  showBack: boolean;
  setShowBack: (value: boolean) => void;
  logoText: string;
  setLogoText: (value: string) => void;
  timerStartAt: Date | null;
  setTimerStartAt: (value: Date | null) => void;
  timerEndAt: Date | null;
  setTimerEndAt: (value: Date | null) => void;
  timerBookId: number | null;
  setTimerBookId: (value: number | null) => void;
  timerType: 'read' | 'script' | null;
  setTimerType: (value: 'read' | 'script' | null) => void;
  bookEventInput: BookeventInputReqDTO | null;
  setBookEventInput: (value: BookeventInputReqDTO | null) => void;
  bookEventFile:File | null;
  setBookEventFile: (value: File | null) => void;
  onBookRegistered: (() => void);
  setOnBookRegistered: (value: () => void) => void;
}

const NoobookContext = createContext<NoobookContextType | undefined>(undefined);

export const NoobookProvider = ({ children }: { children: ReactNode }) => {
  const [showBack, setShowBack] = useState(false);
  const [logoText, setLogoText] = useState('');
  const [timerStartAt, setTimerStartAt] = useState<Date | null>(null);
  const [timerEndAt, setTimerEndAt] = useState<Date | null>(null);
  const [timerBookId, setTimerBookId] = useState<number | null>(null);
  const [timerType, setTimerType] = useState<'read' | 'script' | null>(null);
  const [bookEventInput, setBookEventInput] = useState<BookeventInputReqDTO | null>(null);
  const [bookEventFile, setBookEventFile] = useState<File | null>(null);
  const [onBookRegistered, setOnBookRegistered] = useState<() => void>(() => () => {});
  return (
    <NoobookContext.Provider value={{ showBack, setShowBack, logoText, setLogoText, timerStartAt, setTimerStartAt, timerEndAt, setTimerEndAt, timerBookId, setTimerBookId, timerType, setTimerType, bookEventInput, setBookEventInput, bookEventFile, setBookEventFile, onBookRegistered, setOnBookRegistered }}>
      {children}
    </NoobookContext.Provider>
  );
};

export const useNoobookContext = () => {
  const context = useContext(NoobookContext);
  if (!context) {
    throw new Error('useNoobookContext must be used within a NoobookProvider');
  }
  return context;
};

export default NoobookContext; 